export const pseudoHas = ({ nodes, selector, activeClass }) => {
  if (!nodes?.length || !selector) {
    return
  }

  const nodeList = document.querySelectorAll(nodes)
  const items = Array.from(nodeList).filter((e) => e.querySelector(selector))

  if (items?.length) {
    items.forEach((i) => i.classList.add(activeClass))
  }
}
